// Description: Endpoint to get the profile info
// Updated: 14/06/2026 — Fase 4 (issue #116, épico #113): roteamento
// dapi/toggle/fallback via o helper central src/services/api/dapi/dapiClient.js.
// O caminho Lambda fica INALTERADO (default de produção e destino do fallback).
// Author: Simon Franklin

import axios from 'axios';
import { getTokenData } from '../../../shared/utils/utils';
import {
    DAPI_FLAGS,
    dapiGet,
    callWithDapiFallback,
} from '../dapi/dapiClient';

// Caminho atual (Lambda) — INALTERADO em relação ao histórico.
// É o default de produção e também o destino do fallback.
async function fetchProfileViaLambda({ token, client_id }) {
    const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_AWS_URL}/profile/info`,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${token}`,
                'Client_ID': `${client_id}`
            }
        }
    );
    return response.data;
}

// Caminho alternativo (dapi). Usa o ID token (client_id) no Bearer.
// A resposta é idêntica byte-a-byte à do Lambda (paridade validada no #116),
// então quem consome continua recebendo o mesmo shape (response.data).
async function fetchProfileViaDapi({ client_id }) {
    return dapiGet('/v1/profile/info', client_id);
}

export async function ProfileGet() {
    try {

        const { token, client_id } = await getTokenData();

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!client_id) throw new Error('ID do cliente não encontrado');

        // Modo dapi: tenta a dapi e, em qualquer falha, cai no Lambda.
        // Modo lambda (DEFAULT): caminho atual inalterado.
        return await callWithDapiFallback(
            DAPI_FLAGS.profile,
            () => fetchProfileViaDapi({ client_id }),
            () => fetchProfileViaLambda({ token, client_id })
        );
    } catch (error) {
        return error.response?.data ?? {
            status: 'error',
            message: 'Erro ao carregar perfil.'
        };
    }
}
